import { asyncModule } from '../../utils/async-module';
import { asyncPreactWidget } from '../../utils/async-preact-widget';
import * as JSModules from '../../components/modules';
import * as preactWidgets from '../../preact/widgets';
import { commonActions } from '../../global-store/subjects/common';

export const asyncAuth = () => {
  const { start, getInit, error } = asyncModule(JSModules.authModule);
  start();
  import('../../components/auth/auth').then(getInit()).catch(error);
};

export const asyncLoginOnGlobalNav = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.loginOnGlobalNav);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/login-on-global-nav`).then(hydrate).catch(error);
  }
};

export const asyncUserPreferences = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.userPreferences);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/user-preferences`).then(hydrate).catch(error);
  }
};

export const asyncPaywall = () => {
  const $element = document.querySelector('.j-paywall');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.paywallModule);
    start();
    import('../../components/paywall/paywall').then(getInit($element)).catch(error);
  }
};

export const asyncPremiumPricingTable = () => {
  const $element = document.querySelector('.j-premium-pricing-table');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.premiumPricingTableModule);
    start();
    import('../../components/premium-pricing-table/premium-pricing-table').then(getInit($element)).catch(error);
  }
};
